// Import videos
import showreelVideo from "assets/videos/works/showreel.mp4";
import dynamoVideo from "assets/videos/works/dynamo.mp4";
import ritmoVideo from "assets/videos/works/ritmo.mp4";
import engageVideo from "assets/videos/works/engage.mp4";
import where2BuyVideo from "assets/videos/works/where_2.mp4";
import jff36Video from "assets/videos/works/jff_36.mp4";
import jff34Video from "assets/videos/works/jff_34.mp4";
import powerDryVideo from "assets/videos/works/power_dry.mp4";
import netafimVideo from "assets/videos/works/netafim.mp4";
import littleRedVideo from "assets/videos/works/little_red.mp4";
import fishUsVideo from "assets/videos/works/fish_us.mp4";
import exitVideo from "assets/videos/works/exit.mp4";
import photoIsVideo from "assets/videos/works/photo_is.mp4";

// Import posters
import showreelPoster from "assets/images/posters/showreel.jpg";
import dynamoPoster from "assets/images/posters/dynamo.jpg";
import ritmoPoster from "assets/images/posters/ritmo.jpg";
import engagePoster from "assets/images/posters/engage.jpg";
import where2BuyPoster from "assets/images/posters/where_2.jpg";
import jff36Poster from "assets/images/posters/jff_36.jpg";
import jff34Poster from "assets/images/posters/jff_34.jpg";
import powerDryPoster from "assets/images/posters/power_dry.jpg";
import netafimPoster from "assets/images/posters/netafim.jpg";
import littleRedPoster from "assets/images/posters/little_red.jpg";
import fishUsPoster from "assets/images/posters/fish_us.jpg";
import exitPoster from "assets/images/posters/exit.jpg";
import photoIsPoster from "assets/images/posters/photo_is.jpg";

// Portfolio items data
const portfolioItems = [
  {
    id: 0,
    title: "Showreel: Our Best Work in Action",
    description: "A curated collection of our best animations, showcasing creativity and technical excellence.",
    video: showreelVideo,
    poster: showreelPoster,
  },
  {
    id: 2,
    title: "Ritmo: Launching Startups Towards Success",
    description: "Securing seed funding and helping startups grow with strategic guidance.",
    video: ritmoVideo,
    poster: ritmoPoster,
  },
  {
    id: 1,
    title: "Dynamo: Empowering Technological Innovation",
    description: "Boosting tech startups with innovative resources and strategic support.",
    video: dynamoVideo,
    poster: dynamoPoster,
  },
  {
    id: 3,
    title: "Plus Engage: Revolutionizing Marketing",
    description: "Enhancing marketing with automation and better customer engagement.",
    video: engageVideo,
    poster: engagePoster,
  },
  {
    id: 5,
    title: "JFF 36: A Cinematic Gallop",
    description: "An opener for the 36th Jerusalem Film Festival, full of cinematic artistry.",
    video: jff36Video,
    poster: jff36Poster,
  },
  {
    id: 7,
    title: "Power Dry: Quick Hair Styling",
    description: "Transforming hair care with reduced drying time for faster styling.",
    video: powerDryVideo,
    poster: powerDryPoster,
  },
  {
    id: 6,
    title: "JFF 34: Galloping Through Frames",
    description: "A journey of cinematic exploration for the 34th Jerusalem Film Festival.",
    video: jff34Video,
    poster: jff34Poster,
  },
  {
    id: 9,
    title: "Little Red Head: A Cosmic Cat Odyssey",
    description: "An emotional animation following a man’s longing for his space-traveling cat.",
    video: littleRedVideo,
    poster: littleRedPoster,
  },
  {
    id: 11,
    title: "Exit: Bezalel's Artistic Finale Showcase",
    description: "An animated invitation for the grand graduation exhibition of Bezalel art students.",
    video: exitVideo,
    poster: exitPoster,
  },
  {
    id: 10,
    title: "Fish Us: Echoes of the Ensnared",
    description: "A thought-provoking animation questioning freedom and oppression.",
    video: fishUsVideo,
    poster: fishUsPoster,
  },
  {
    id: 12,
    title: "Photo Is:Real: Capturing Global Perspectives",
    description: "An engaging animated invitation for an international photography exhibition.",
    video: photoIsVideo,
    poster: photoIsPoster,
  },
  {
    id: 8,
    title: "Netafim: Cultivating Growth in Africa",
    description: "Showcasing innovative irrigation solutions for sustainable agriculture.",
    video: netafimVideo,
    poster: netafimPoster,
  },
  {
    id: 4,
    title: "Where2Buy: Bridging Shoppers and Businesses",
    description: "Connecting online shoppers with local stores to boost commerce.",
    video: where2BuyVideo,
    poster: where2BuyPoster,
  },
];

export default portfolioItems;
